import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  state = {
    checked: this.props.checked,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { checked } = this.props;
    if (checked !== nextProps.checked) {
      this.setState({
        checked: nextProps.checked,
      });
    }
  }

  handleChange = (e) => {
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));

    this.props.onChange(e);
  };

  render() {
    const {
      disabled,
      wrapClass,
      id,
      labelClass,
      name,
      value,
      label,
    } = this.props;

    const { checked } = this.state;

    return (
      <div className={wrapClass}>
        <label htmlFor={id} className={labelClass}>
          <input
            id={id}
            name={name}
            value={value}
            type="checkbox"
            className="React__checkbox--input"
            checked={checked}
            disabled={disabled}
            onChange={this.handleChange}
          />
          <span className="React__checkbox--span">{label}</span>
        </label>
      </div>
    );
  }
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  wrapClass: PropTypes.string,
  labelClass: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  id: '',
  name: '',
  value: '',
  label: '',
  onChange: null,
  wrapClass: '',
  labelClass: '',
};

export default Checkbox;
